import { useLocation } from 'react-router-dom';

// see https://reactrouter.com/web/example/query-parameters
export function useQuery<T>() {
  const location = useLocation<{ search: T }>();
  return new URLSearchParams(location.search);
}
